import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const INVESTORS = [
  { name: "Wintech Labs", initial: "WL" },
  { name: "Unicorn Management", initial: "UM" },
  { name: "RP Enterprises", initial: "RP" },
  { name: "Salasaar Technologies", initial: "ST" },
];

export default function Investors() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/[0.06]" data-testid="investors-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          align="center"
          chapter="Chapter 09"
          kicker="Backed By"
          title="Our Investors"
          subtitle="Winter Protocol is supported by partners who share the long-term ecosystem vision."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {INVESTORS.map((inv, i) => (
            <Reveal key={inv.name} delay={i * 0.07}>
              <div
                className="group flex h-full flex-col items-center justify-center gap-6 glass-card px-6 py-12 text-center transition-all duration-500 hover:border-[#D4AF37]/30"
                data-testid={`investor-card-${i + 1}`}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] font-display text-lg font-bold tracking-widest text-[#99A1AF] transition-all duration-500 group-hover:border-[#D4AF37]/40 group-hover:text-[#D4AF37]">
                  {inv.initial}
                </div>
                <div>
                  <p className="font-display text-lg font-semibold tracking-wide text-white">{inv.name}</p>
                  <p className="mt-2 font-mono text-[10px] tracking-[0.3em] text-[#3A3F4A] uppercase">
                    Investor {String(i + 1).padStart(2, "0")}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
